import { Component }  from 'react';
import { Form ,Input } from 'antd';

export default class AdminFrom extends Component{

  constructor(props) {
    super(props);
    this.form = null;
    this.state = {
      prevEditAccount: null,
    };
  }

  setFormValues(props) {
    const { modalData, form } = props;
    if (
      modalData.btnAction === 'EditBtn' && 
      modalData.adminUserEdit &&
      modalData.adminUserEdit.account !== this.state.prevEditAccount
    ) {
      form.current.setFieldsValue(modalData.adminUserEdit);
    }else if(modalData.btnAction === 'AddBtn') {
      form.current.resetFields();
    }
    this.setState({ prevEditAccount: modalData.adminUserEdit.account }); 
  }

  componentDidMount() {
    this.setFormValues(this.props);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.modalData.btnAction !== prevProps.modalData.btnAction ||
      this.props.modalData.adminUserEdit?.account !== this.state.prevEditAccount 
    ) {
      this.setFormValues(this.props);
    }
  }

    render() {
      return (
        <Form
              ref={this.props.form}
              layout="vertical"
          >
              <Form.Item label="Account" name="account" 
                  rules={[{ required: true, message: 'Please enter your account' }]}
              >
                <Input disabled={this.props.modalData.btnAction === 'EditBtn'}/>
              </Form.Item>
              <Form.Item label="User Name" name="name"
                  rules={[{ required: true, message: 'Please enter your user name' }]}
              >
                <Input />
              </Form.Item>
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={
                      this.props.modalData.btnAction === 'AddBtnA'
                      ? [
                          { required: true, message: 'Please enter your password' },
                          { min: 8, message: 'Password must be at least 8 characters' },
                          { max: 20, message: 'Password must be at most 20 characters' },
                          {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*]).+$/,
                            message: 'Password can only contain letters, numbers, and underscores',
                          },
                        ]
                      : [ 
                          {
                            validator: (_, value) => {
                              if (!value) {
                                // 非必填，空值不報錯
                                return Promise.resolve();
                              }
                              if (value.length < 8) {
                                return Promise.reject(new Error('Password must be at least 8 characters'));
                              }
                              if (value.length > 20) {
                                return Promise.reject(new Error('Password must be at most 20 characters'));
                              }
                              const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*]).+$/;
                              if (!regex.test(value)) {
                                return Promise.reject(
                                  new Error('Password can only contain letters, numbers, and underscores')
                                );
                              }
                              return Promise.resolve();
                            },
                          }
                        ]
                    }
                  >
                    <Input.Password placeholder="Please enter your password" />
                  </Form.Item>
              {this.props.errorMessage && (
                <div style={{ color: 'red', marginBottom: '1rem' }}>{this.props.errorMessage}</div>
              )}
          </Form>
      );
    }
}